import { render } from "./UpdatePaymentDateModal.vue?vue&type=template&id=2affce56&scoped=true"
import script from "./UpdatePaymentDateModal.vue?vue&type=script&lang=js"
export * from "./UpdatePaymentDateModal.vue?vue&type=script&lang=js"

import "./UpdatePaymentDateModal.vue?vue&type=style&index=0&id=2affce56&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2affce56"]])

export default __exports__